




















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import CreateEventForm from '@/active-components/dashboard/CreateEventForm.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { EventFormData, EventResponse, EventUpdate } from '@/model/Event';
import { Project } from '@/model/Project';
import { ApiError } from '@/model/ApiError';

@Component({
    components: {
        CreateEventForm,
    },
    computed: {
        ...mapGetters({
            getProjects: 'customerProjectStorage/getProjects',
            eventError: 'eventStorage/getError',
        }),
    },
    methods: {
        ...mapMutations({
            setError: 'eventStorage/setError',
        }),
        ...mapActions({
            create: 'eventStorage/create',
            fetchEvents: 'eventStorage/fetchEvents',
            getAllProjects: 'customerProjectStorage/getAllProjects',
            update: 'eventStorage/updateEvent',
        }),
    },
})
export default class CreateEventModal extends Vue {
    @Prop({ type: Boolean }) isUpdate?: boolean;

    @Prop() item!: EventResponse;

    loading = false;

    create!: (formData: EventFormData) => Promise<void | EventResponse>;

    update!: (formData: EventUpdate) => Promise<void>;

    setError!: (error: ApiError | null) => void;

    fetchEvents!: () => Promise<void | EventResponse[]>;

    getProjects!: () => Project[];

    getAllProjects!: (onlyActives: boolean) => Promise<void>;

    mounted(): void {
        this.getAllProjects(true);
    }

    destroyed(): void {
        this.setError(null);
    }

    @Emit()
    close(): void {
        // close
    }

    @Emit()
    success(): void {
        // success
    }

    onSubmit(formData: EventFormData | EventUpdate): void {
        this.loading = true;
        const method = this.isUpdate
            ? this.update(formData as EventUpdate)
            : this.create(formData as EventFormData);

        method
            .then(() => {
                this.fetchEvents();
                this.success();
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
